<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form" v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" md="8">
            <GradeClassStudentSelect
              :gradeCol="{ cols: 12, md: 6 }"
              :classCol="{ cols: 12, md: 6 }"
              disableStudentSelect
              @changed="gradeClassChange"
            />
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12" md="4">
            <AutocompleteSubjectGroup
              clear-icon="mdi-close"
              label="Bộ môn"
              dense
              hide-details
              outlined
              @change="subjectGroupChanged"
            />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteSubject
              v-model="subject"
              clear-icon="mdi-close"
              label="Môn học"
              outlined
              dense
              :filter="subjectFilter"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <DateIOSPicker
              label="Ngày"
              :date.sync="datetime"
              outlined
              :rules="[$rules.date, $rules.dateFromNow]"
              dense
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import GradeClassStudentSelect from '../../components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker'

export default {
  components: {
    GradeClassStudentSelect,
    AutocompleteSubject,
    AutocompleteSubjectGroup,
    DateIOSPicker
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    subjectGroup: '',
    subject: '',
    datetime: moment().toISOString()
  }),
  methods: {
    gradeClassChange(data) {
      if (get(this.selectedGrade, 'academicLevel') !== get(data.grade, 'academicLevel')) {
        this.selectedClass = {}
        this.subjectGroup = ''
        this.subject = ''
      }
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
    },
    onFilterChanged() {
      if (!this.$refs.form.validate()) return

      if (this.subjectGroup && !this.subject) {
        this.$alert.error('Chưa chọn Môn học')
        return
      }

      this.$emit('onFilterChanged', {
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        subject: this.subject || undefined,
        date: this.datetime
      })
    },
    subjectGroupChanged(subjectGroup) {
      if (subjectGroup && subjectGroup !== this.subjectGroup) {
        this.subject = ''
      }
      this.subjectGroup = subjectGroup
    }
  },
  computed: {
    ...mapState('subjects', ['subjects']),
    subjectFilter() {
      return { subjectGroup: this.subjectGroup, grade: get(this.selectedGrade, 'id') }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
